/**
 * 全站用功能
 * Author: Jay Hsu
 * Date: 2022-06-29
 */

 module.exports = {
    globalEvent() {
        $("#mNavBtn").on('click', () => {
            $("#mobileNav").addClass('show');
            $("body").addClass('mMenuOpen');
        });

        $("#mobileNav .closeBtn").on('click', () => {
            $("#mobileNav").removeClass('show');
            $("body").removeClass('mMenuOpen');
        });

        $('.toTop').on('click', (e) => {
            e.preventDefault();
            $('html,body').animate({
            scrollTop: 0,
            }, 1000)
        });

        //統計用
        $(".statistic").on('click', (e) => {
            //e.preventDefault();
            let $this = $(e.currentTarget);
            this.fnGet({
                url: `${$this.data('api')}?item=${$this.data('item')}&key=${$this.data('key')}`
            });

            return true
        })

        this.topScroll();
        $(window).on('scroll', () => {
            this.topScroll();
        });

        //lazyload
        this.fnLazyload()
    },
    topScroll(){
        if($('html,body').scrollTop() > 0){
            $(".toTop").removeClass('hide')
            $("header").addClass('scrolldown')
        }else{
            $(".toTop").addClass('hide')
            $("header").removeClass('scrolldown')
        }
    },
    //基本Fetch get
    fnGet(...rest) {
        const param = Object.assign({
            url: ''
        },...rest)

        return fetch(param.url, {
            headers : {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        })
    },
    //基本Fetch post
    fnPost(...rest) {
        const param = Object.assign({
            url: '',
            data: {}
        },...rest)

        return fetch(param.url, {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "X-Requested-With": "XMLHttpRequest",
                "X-CSRF-Token": $('input[name="_token"]').val()
            },
            method: "post",
            credentials: "same-origin",
            body: JSON.stringify(param.data)
        })
    },
    //create uuid with md5 encode
    fnUUID(){
        return $.md5(Math.random()+(Math.floor(Date.now() / 1000))+Math.random())
    },
    fnLazyload(){
        $(".lazyload").each(function(){
            var original_src = $(this).attr('src')
            $(this)
            .attr('src', window.location.origin+'/img/loading.gif')
            .attr('data-original', original_src)
            .lazyload({effect: "fadeIn"})
        })
    }
 }
